/**
 * VKN (Vergi Kimlik Numarası) doğrulama — 10 haneli, GİB algoritması.
 *
 * Algoritma kaynak: https://www.gib.gov.tr/
 */
export function isValidVKN(vkn: string): boolean {
  if (!/^\d{10}$/.test(vkn)) return false;

  const digits = vkn.split('').map(Number);
  const lastDigit = digits[9]!;
  let sum = 0;

  for (let i = 0; i < 9; i++) {
    const digit = digits[i]!;
    const tmp = (digit + (9 - i)) % 10;
    if (tmp === 0) continue;
    // Resmi GİB kuralı: ara sonuç 0 çıkarsa (tmp ≠ 0 iken) 9 olarak sayılır.
    // Eski kod bu kuralı atlıyordu → tmp==9 üreten pozisyonlarda geçerli VKN'leri
    // (ör. vergi dairesi VKN'leri) yanlışlıkla reddediyordu.
    const partial = (tmp * 2 ** (9 - i)) % 9;
    sum += partial === 0 ? 9 : partial;
  }

  const checkDigit = (10 - (sum % 10)) % 10;
  return checkDigit === lastDigit;
}

/**
 * VKN'yi maskeleme — log/UI için (son 3 hane görünür).
 * @example maskVKN("1234567890") === "*******890"
 */
export function maskVKN(vkn: string): string {
  if (vkn.length !== 10) return vkn;
  return '*'.repeat(7) + vkn.slice(7);
}
